module.exports = __webpack_public_path__ + "img/album-cover.cb2c284b.png";